import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Admin from "./features/auth/pages/Admin";

const App = () => {
  const isUserAuthenticated = () => {
    const sessionToken = localStorage.getItem("sessionToken");
    return typeof sessionToken === "string" && sessionToken.trim() !== "";
  };
  return (
    <Router>
      <Routes>
        <Route path="*" element={isUserAuthenticated() ? <Home /> : <Admin />} />
      </Routes>
    </Router>
  );
};

export default App;
